/*
 * @Descripttion: 处方明细成本处理
 * @version:
 * @Author: AI
 * @email:
 * @Date: 2026-10-14 18:10:32
 * @LastEditors: AI
 * @LastEditTime: 2026-10-14 18:10:32
 */

/**
 * 诊疗项目成本修正。
 *
 * recipeitem/batchsave 会把请求体里的 costPrice 当作“单个成本”，
 * 再乘以数量重算成本总价；而处方明细接口回显的 costPrice 是历史的“成本总价”。
 * 因此编辑已经保存过的诊疗项目明细时，直接把回显的 costPrice 传回去，
 * 就会被再乘一次数量，导致每修改一次成本就被放大一次。
 *
 * 处理方式：
 * 1. 已存在的诊疗明细（treatmentServiceId 与 id 都有值）改传成本单价 costUnitPrice；
 * 2. 取不到成本单价时不下发 costPrice，交由后端按诊疗目录的成本价重新计算；
 * 3. 新增的诊疗项目（无 id）保持原样，页面传的就是诊疗目录的单个成本。
 */
export function normalizeTreatmentItemCostPrice(m: any): any {
  if (!m || !(Number(m.treatmentServiceId) > 0) || !(Number(m.id) > 0)) {
    return m
  }

  const costUnitPrice = Number(m.costUnitPrice)

  if (
    m.costUnitPrice !== null &&
    m.costUnitPrice !== undefined &&
    !isNaN(costUnitPrice) &&
    costUnitPrice > 0
  ) {
    return { ...m, costPrice: costUnitPrice }
  }

  return { ...m, costPrice: undefined }
}
